export default "<app-loading [show]=\"loading\"></app-loading>\n\n<router-outlet></router-outlet>\n"